import { Data, Effect } from 'effect';

export class ConfigNotLoaded extends Data.TaggedError('ConfigNotLoaded') {}

export class EarlierSaveFailed extends Data.TaggedError('EarlierSaveFailed') {}

export class CompanyChanged extends Data.TaggedError('CompanyChanged') {}

export class ConfigsRequestFailed extends Data.TaggedError('ConfigsRequestFailed')<{
  readonly originalError: unknown;
}> {}

export class ConfigsAnswerHasNoList extends Data.TaggedError('ConfigsAnswerHasNoList') {}

export type LoadError = CompanyChanged | ConfigsRequestFailed | ConfigsAnswerHasNoList;
export type SaveError = ConfigNotLoaded | EarlierSaveFailed | CompanyChanged | ConfigsRequestFailed;
export type PropagateError = SaveError;

export const sendConfigsRequest = <A>(send: () => Promise<A>) =>
  Effect.tryPromise({ try: send, catch: (originalError) => new ConfigsRequestFailed({ originalError }) });
